(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9807],{

/***/ 7787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/wedding/detail",
      function () {
        return __webpack_require__(7367);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ RoomDetail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _components_DetailPageV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6081);
/* harmony import */ var _components_FormMeeting__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7080);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1914);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9741);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var __N_SSG = true;
function RoomDetail(param) {
    var header = param.header, hotelBrands = param.hotelBrands;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), isReady = ref.isReady, query = ref.query, push = ref.push, locale = ref.locale;
    var ref1 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useFetchSWRv2 */ .bX)("wedding", {
        _ID: query.id,
        cct_status: "publish"
    }), 1), weddingTemp = ref1[0];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), wedding = ref2[0], setWedding = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (isReady) {
            if (!query.id) {
                push("/".concat(header.slug, "/meeting-events"));
            }
            if (weddingTemp) {
                var temp = weddingTemp[0];
                if (locale == "id") {
                    var x = JSON.stringify(weddingTemp[0]);
                    var y = x.replace(/_id/g, "");
                    temp = JSON.parse(y);
                } else {
                    var x1 = JSON.stringify(weddingTemp[0]);
                    var y1 = x1.replace(/_en/g, "");
                    temp = JSON.parse(y1);
                }
                setWedding(temp);
            }
        }
    }, [
        weddingTemp,
        locale,
        isReady
    ]);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isFormOpen1 = ref3[0], setIsFormOpen = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (isFormOpen1) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [
        isFormOpen1
    ]);
    var isXLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__/* .useLargeQuery */ .fc)().isXLarge;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Wedding | Parador Hotels & Resorts",
                description: wedding === null || wedding === void 0 ? void 0 : wedding.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            wedding ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DetailPageV2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                headline: locale == "id" ? "PERNIKAHAN" : "WEDDING",
                subHeadline: locale == "id" ? "Rencanakan pernikahan di ".concat(header.name, ". Wujudkan impian pernikahan dambaanmu.") : "Plan a wedding at ".concat(header.name, ". And make your wedding dream come true."),
                backTo: {
                    text: locale == "id" ? "Pernikahan" : "Wedding",
                    link: "/".concat(header.slug, "/wedding")
                },
                button: {
                    text: locale == "id" ? "PESAN SEKARANG" : "ENQUIRE NOW",
                    link: function(isFormOpen) {
                        return setIsFormOpen(isFormOpen);
                    },
                    scroll: 500
                },
                title: wedding.title,
                price: wedding.start_from,
                description: wedding.description ? wedding.description : "",
                accordionItems: [
                    {
                        items: null,
                        title: locale == "id" ? "Bagikan" : "Share",
                        type: "share"
                    },
                    {
                        items: [
                            {
                                name: locale == "id" ? "Brosur" : "Brochure",
                                item: wedding.brochures
                            }, 
                        ],
                        title: locale == "id" ? "Unduh" : "Download",
                        type: "download"
                    },
                    {
                        items: wedding.includes,
                        title: locale == "id" ? "Sudah Termasuk" : "Stay Includes",
                        type: "list"
                    },
                    {
                        items: wedding.tac,
                        title: locale == "id" ? "Ketentuan & Kondisi" : "Terms & Conditions",
                        type: "list"
                    }, 
                ],
                color: header.color_primary,
                images: wedding.gallery
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    flexDir: "column",
                    w: "100%",
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .OdW, {
                            height: "80px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                            gap: 6,
                            children: [
                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .OdW, {
                                    flex: 6,
                                    height: "100vh"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .OdW, {
                                    flex: 12,
                                    height: "100vh"
                                })
                            ]
                        })
                    ]
                })
            }),
            isFormOpen1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormMeeting__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                emailParticipants: header.email_participants,
                button: function(isFormOpen) {
                    return setIsFormOpen(isFormOpen);
                },
                color: header.color_primary,
                hotel: header.name,
                type: "wedding",
                headline: locale == "id" ? "PERMINTAAN UNTUK PERNIKAHAN" : "WEDDING ENQUIRY",
                contactWa: wedding === null || wedding === void 0 ? void 0 : wedding.kontak_wa
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                hotelSlug: header.slug,
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: "white",
                logo: header.logo_light
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,5525,6394,9392,3522,4939,8078,2930,9774,2888,179], function() { return __webpack_exec__(7787); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);